export const MYSHOPIFY_SUFFIX = '.myshopify.com';

export const isShopifyShop = (shopName?: string | null) =>
  (shopName ?? '').trim().toLowerCase().endsWith(MYSHOPIFY_SUFFIX);

export type ShopifySection<T> = { data: T | null; error: string | null };

export type ShopifyOwner = {
  name: string;
  shopOwnerName: string | null;
  email: string | null;
  contactEmail: string | null;
  myshopifyDomain: string;
  primaryDomain: { host: string } | null;
  ianaTimezone: string | null;
  currencyCode: string | null;
  createdAt: string;
  plan: { publicDisplayName: string; partnerDevelopment: boolean; shopifyPlus: boolean } | null;
  billingAddress: { phone: string | null; city: string | null; province: string | null; country: string | null } | null;
};

export type ShopifyWebhook = {
  id: string;
  topic: string;
  uri: string;
  format: string;
  filter: string | null;
  includeFields: string[];
  createdAt: string;
  updatedAt: string;
};

export type DefaultWebhook = { topic: string; label: string; uri: string };

export type FixWebhooksResult = {
  created: string[];
  existing: string[];
  failed: { topic: string; error: string }[];
};

export type ShopifyDetailsResponse = {
  shop_name: string;
  api_version: string;
  default_webhooks: DefaultWebhook[];
  owner: ShopifySection<ShopifyOwner>;
  webhooks: ShopifySection<ShopifyWebhook[]>;
  // Every WebhookSubscriptionTopic the shop's API version supports.
  topics: ShopifySection<string[]>;
};

export type ShopifyGraphqlResult = {
  // Shopify's HTTP status; GraphQL errors usually come back with 200.
  status: number;
  mutation: boolean;
  response: unknown;
};

// Comments and string literals, which may mention "mutation" without being one. Mirrors the API's check.
const GRAPHQL_IGNORED = /"""[\s\S]*?"""|"(?:\\.|[^"\\\n])*"|#[^\n]*/g;

export const isGraphqlMutation = (query: string) => /\bmutation\b/.test(query.replace(GRAPHQL_IGNORED, ' '));

// A row of product_shopify.job_history. CS can only set its status to DONE, or delete it.
export type ShopifyJob = {
  id: number;
  job_id: string | null;
  type: string | null;
  status: string | null;
  shop_id: string;
  created_at: string | null;
  updated_at: string | null;
  total: number | null;
};

export type ShopifyJobsResponse = {
  // All of the shop's jobs; `jobs` holds at most `limit` of the newest.
  count: number;
  limit: number;
  jobs: ShopifyJob[];
};

export const JOB_DONE = 'DONE';
